import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="text-center pt-3xl">
      <h1 className="text-mega text-lighter">404</h1>
      <p className="text-secondary mb-lg">{t('error.notFound')}</p>
      <Button component={Link} to="/tasks" variant="contained">
        {t('error.backHome')}
      </Button>
    </div>
  );
}
